import { render, staticRenderFns } from "./table-footer-pagination.vue?vue&type=template&id=091b31d1&scoped=true"
import script from "./table-footer-pagination.vue?vue&type=script&lang=js"
export * from "./table-footer-pagination.vue?vue&type=script&lang=js"
import style0 from "./table-footer-pagination.vue?vue&type=style&index=0&id=091b31d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091b31d1",
  null
  
)

export default component.exports